import styled from 'styled-components';

export const OrderTaskWrapper = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;

  & > * {
    padding: 15px 0;
  }
`;

export const OrderTaskTitle = styled.h3`
  text-align: center;
  font-size: 2.5rem;
  color: #001758;
  font-family: Lato-Light, sans-serif;
  font-weight: 300;
  line-height: 3.1rem;
  margin-top: 2rem;
  margin-bottom: 0;
`;

export const OrderTaskDescription = styled.div`
  padding-left: 2rem;
  padding-right: 2rem;
  font-family: Lato-Light, sans-serif;
  font-weight: lighter;
  text-align: center;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: #114754;
`;

export const BackButton = styled.button`
  background-color: #44b1df;
  width: 15rem;
  border: 0;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2rem;

  &:hover {
    background-color: #545454;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: #114754;
  font-family: lato, sans-serif;
  font-weight: 400;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 15px;
  width: 50%;
  max-width: 700px;
`;

export const CommentTextarea = styled.textarea`
  width: 100%;
  min-height: 12rem;
  max-height: 20rem;
  background-color: #ffffff;
  border: 0.1rem solid #97bbc1;
  border-radius: 1rem;
  color: #114754;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2.5rem;
  padding: 1rem;
  max-width: 100%;
`;

export const OrderListWrapper = styled.div`
  background-color: #edf3f7;
  margin-bottom: 10px;
`;

export const OrderListTitle = styled.h4`
  text-align: center;
  font-size: 2rem;
  color: #001758;
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  margin-top: 1rem;
`;

export const OrderList = styled.div`
  list-style: none;
  margin: 0;
  padding: 0;

  text-align: center;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: #114754;
  font-family: lato, sans-serif;
  font-weight: 400;
`;

export const OrderTaskControls = styled.div`
  min-height: 48px;
  padding: 1.2rem 15px;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;

export const OrderTaskButton = styled.button`
  background-color: black;
  width: 13rem;
  border: 0 #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2rem;
`;

export const OrderBackButton = styled(OrderTaskButton)`
  background-color: #0bc495;
`;

export const OrderActionButton = styled(OrderTaskButton)`
  background-color: #44b1df;
`;
